<template>
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <GroupEditor
      :isShow="isEditorShow"
      :group="selectedItem"
      @close="
        selectedItem = { identity: '', name: '' };
        isEditorShow = false;
      "
      @save="savedGroup"
    ></GroupEditor>
    <UploadGroupModal
      :isShow="isUploadShow"
      id=""
      @close="isUploadShow = false;getGroups();">
    </UploadGroupModal>
    <v-breadcrumbs
      :items="breadcrumbs"
      large
      style="padding-bottom: 0px"
    ></v-breadcrumbs>

    <v-data-table
      class="mt-2"
      style="width: 96%; margin-left: 2%"
      :headers="headers"
      :items="groupList"
      :loading="isTableLoading"
      item-key="identity"
      :search="search"
      :options.sync="options"
      :server-items-length="totalItems"
    >
      <template v-slot:top>
        <v-tabs v-model="type" style="width: 96%; margin-left: 2%" class="ml-6" color="primary">
          <v-tab>University</v-tab>
          <v-tab>Custom</v-tab>
        </v-tabs>
        <v-toolbar flat>
          <v-toolbar-title>Activated Groups</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            class="mt-3"
            label="SEARCH"
            v-model="search"
            @change="getGroups"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            color="primary"
            @click="isEditorShow = true"
            v-if="type == 1"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>NEW</v-btn
          >
            <v-btn
            class="mr-2"
            color="primary"
            @click="isUploadShow = true"
            v-if="type == 1"
          >
            <v-icon class="mr-2">mdi-upload</v-icon>UPLOAD</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon @click="showDetails(item)" class="mr-2"
          >mdi-account-details-outline</v-icon
        >
        <v-icon @click="deleteItem(item)" v-show="type==1">mdi-delete</v-icon>
      </template>

      <template v-slot:item.isEnabled="{ item }">
        <v-btn
          :color="item.isEnabled ? 'green' : 'red'"
          outlined
          small
          width="100"
          @click="
            item.isEnabled = !item.isEnabled;
            save(item);
          "
          >{{ item.isEnabled ? "Activated" : "Inactivated" }}</v-btn
        >
      </template>
    </v-data-table>

  <v-data-table
      class="mt-1"
      style="width: 96%; margin-left: 2%"
      :headers="headers"
      :items="inactiveGroups"
      :loading="isTableLoading"
      item-key="identity"
      :search="search"
      :options.sync="options"
      :server-items-length="totalInactItems"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>InActivated Groups</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
         <!-- <v-text-field
            class="mt-3"
            label="SEARCH"
            v-model="search"
            @change="getGroups"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            color="primary"
            @click="isEditorShow = true"
            v-if="type == 1"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>NEW</v-btn
          >
            <v-btn
            class="mr-2"
            color="primary"
            @click="isUploadShow = true"
            v-if="type == 1"
          >
            <v-icon class="mr-2">mdi-upload</v-icon>UPLOAD</v-btn
          >-->
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon @click="showDetails(item)" class="mr-2"
          >mdi-account-details-outline</v-icon
        >
        <v-icon @click="deleteItem(item)" v-show="type==1">mdi-delete</v-icon>
      </template>

      <template v-slot:item.isEnabled="{ item }">
        <v-btn
          :color="item.isEnabled ? 'green' : 'red'"
          outlined
          small
          width="100"
          @click="
            item.isEnabled = !item.isEnabled;
            save(item);
          "
          >{{ item.isEnabled ? "Activated" : "Inactivated" }}</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { userService } from "@/api/user-service";
import GroupEditor from "@/components/Modals/GroupEditor";
import UploadGroupModal from '@/components/Modals/UploadGroupModal'
import { mapGetters } from 'vuex';

export default {
  name: "ManageGroup",
  components: { GroupEditor, UploadGroupModal },
  computed:{
    ...mapGetters(['userProfile'])
  },
  data: () => {
    return {
      isLoading: false,
      isTableLoading: false,
      search: "",
      type: 0,
      groupList: [],
      activeGroups: [],
      inactiveGroups: [],
      selectedItem: { identity: "", name: "" },
      isEditorShow: false,
      isUploadShow: false,
      totalItems: 0,
      totalInactItems: 0,
      options: {},
      headers: [
        { text: "", value: "isEnabled", width: "10%", sortable:false },
        { text: "Name", value: "name", width: "75%", sortable:false },
        // { text: "Email", value: "email", width: "10%", sortable: false },
        // { text: "Role", value: "departments", width: "30%", sortable: false },
        { text: "Actions", value: "actions", width: "10%", sortable: false },
      ],
      breadcrumbs: [
        {
          text: "< Home",
          href: "",
          disabled: false,
          href: "/",
        },
        {
          text: "Groups",
          href: "",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    capitalizeFirstLetter(str) {
      if (str == "") return "";
      const capitalized = str[0].charAt(0).toUpperCase() + str[0].slice(1);
      return capitalized;
    },
    async init() {
      this.isLoading = true;
      this.groupList = await userService.getGroup(1, 10, "", "", "").result;
      this.isLoading = false;
    },
    async getGroups() {
      this.groupList = [];
      this.inactiveGroups = [];

      this.totalItems = 0;
      this.totalInactItems = 0;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.isTableLoading = true;
      let response = await userService.getGroup(
        page,
        itemsPerPage,
        this.capitalizeFirstLetter(sortBy),
        sortDesc,
        this.search,
        this.type
      );
      if (response.total > 0) {
        this.totalItems = response.total;
        this.groupList = response.result;
      }

      response = await userService.getGroup(
        page,
        itemsPerPage,
        this.capitalizeFirstLetter(sortBy),
        sortDesc,
        this.search,
        this.type,
        false
      );
      if (response.total > 0) {
        this.totalInactItems = response.total;
        this.inactiveGroups = response.result;
      }

      this.isTableLoading = false;
    },
    showDetails(item) {
      this.selectedItem = item;
      this.isEditorShow = true;
    },
    async deleteItem(item) {
      if (item.isEnabled) {
        alert("You are not able to delete an actived group");
        return;
      }
      let yes = confirm("Do you want to delete this group?");
      if (yes) {
        await userService.delGroup(item);
        this.getGroups();
      }
    },
    async save(item) {
      let result = await userService.updateGroup(item);
      if (result.indexOf('inactivate')!=-1)
      {
        alert(result);
        item.isEnabled = true;
        return;
      }
      if (item.isEnabled)
      {
        let idx = this.inactiveGroups.findIndex(x=>x.identity == item.identity)
        this.inactiveGroups.splice(idx, 1);
        this.groupList.push(item)
        this.totalItems++;
        this.totalInactItems--;
      }
      else
      {
        let idx = this.groupList.findIndex(x=>x.identity == item.identity)
        this.groupList.splice(idx, 1);
        this.inactiveGroups.push(item);
        this.totalItems--;
        this.totalInactItems++;
      }
    },
    create() {},
    savedGroup(item) {
      this.selectedItem = item;
      this.getGroups();
    },
  },
  watch: {
    search(val) {
      //this.init();
    },
    options: {
      handler() {
        this.getGroups();
      },
      deep: true,
    },
    type() {
      this.getGroups();
    },
  },
  mounted() {
    if (!this.userProfile || (!this.userProfile.isCalendarAdmin && !this.userProfile.isAdmin))
      this.$router.push('/')
    //this.init();
  },
};
</script>

<style>
.v-breadcrumbs{
  font-weight: bold;
  background-color: #eee;
  padding: 5px 24px!important;
}
</style>